// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessageCenter_wrapper___Dqkl","active":"MessageCenter_active__3o1fG","users":"MessageCenter_users__2sTIp","messages":"MessageCenter_messages__3VG2G"};